import React from "react";
import { apiUpcomingProjectCompletions } from '../../services/apis/retail/apiUpcomingProjectCompletions';

class UpcomingProjectCompletions extends React.Component {
    state = {
        upcomingProjectCompletions: []
    }

    componentDidMount() {
        apiUpcomingProjectCompletions.get().then((res) => {
            this.setState({ upcomingProjectCompletions: res.data });
        });
    }

    render() {
        return (
            <div className="col-lg-4">
                <div className="widget widgetUpcoming">
                    <h3>Upcoming Project Completions</h3>
                    {this.state.upcomingProjectCompletions.map((row, i) => (
                        <div key={i}>
                            <h5 className="mt-3">{row.developer}</h5>
                            <h5 className="mb-3">{row.project}</h5>
                            <div className="row ms-1 me-1" >
                                <div className="darkBlueBg">
                                    <div className="row">
                                        <div className="col-lg-4">
                                            <img alt="Project Incomplete Icon" src="/edge/images/incomplete_icon.png" />
                                        </div>
                                        <div className="col-lg-8">
                                            <p className="text-start">Completion Date</p>
                                            <h5>{row.completion_date}</h5>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}

                    {/* <h5 className="mt-3">DLF</h5>
                    <h5 className="mb-3">Downtown Phase - II</h5>
                    <div className="row ms-1 me-1">
                        <div className="darkBlueBg">
                            <div className="row">
                                <div className="col-lg-4">
                                    <img alt="Project Incomplete Icon" src="/edge/images/incomplete_icon.png" />
                                </div>
                                <div className="col-lg-8">
                                    <p className="text-start">Completion Date</p>
                                    <h5>December 2021</h5>
                                </div>
                            </div>
                        </div>
                    </div>
                    <h5 className="mt-5">Mindspace</h5>
                    <h5 className="mb-3">Aster Phase - II</h5>
                    <div className="row ms-1 me-1">
                        <div className="darkBlueBg">
                            <div className="row">
                                <div className="col-lg-4">
                                    <img alt="Project Incomplete Icon" src="/edge/images/incomplete_icon.png" />
                                </div>
                                <div className="col-lg-8">
                                    <p className="text-start">Completion Date</p>
                                    <h5>December 2021</h5>
                                </div>
                            </div>
                        </div>
                    </div> */}
                </div>
            </div>

        );
    }
}

export default UpcomingProjectCompletions;
